import React, { useEffect, useState } from 'react';

const Candidates = () => {
  const [jobs, setJobs] = useState([]);
  const [activeFilter, setActiveFilter] = useState('trending');
  const [searchQuery, setSearchQuery] = useState('');

  // Mock job data based on the screenshot
  useEffect(() => {
    const mockJobs = [
      {
        id: 1,
        title: 'Member of Program Staff',
        company: 'xAI',
        logo: '🖤', // Black square with white xAI
        location: 'Remote',
        type: 'Full-time',
        salary: '$140K-$196K / year',
        referralBonus: '+ $10,000',
        postedAt: '2 days ago',
        offersEquity: true,
        isHighlighted: false
      },
      {
        id: 2,
        title: 'Technical Recruiter',
        company: 'Mercor',
        logo: '🟣', // Purple M logo
        location: 'Remote',
        type: 'Full-time',
        salary: '$120K-$180K / year',
        referralBonus: '+ $10,000',
        postedAt: '1 day ago',
        offersEquity: true,
        isHighlighted: false
      },
      {
        id: 3,
        title: 'Medical Expert',
        company: 'Healthcare Corp',
        logo: '⚪', // White heart outline
        location: 'Remote',
        type: 'Contract',
        salary: '$175 / hour',
        referralBonus: '+ $500',
        postedAt: '6 days ago',
        offersEquity: false,
        isHighlighted: true
      },
      {
        id: 4,
        title: 'Senior Software Engineer',
        company: 'Tech Solutions',
        logo: '⚪', // White circuit board
        location: 'Remote',
        type: 'Contract',
        salary: '$100-$200 / hour',
        referralBonus: '+ $250',
        postedAt: '16 days ago',
        offersEquity: false,
        isHighlighted: false
      },
      {
        id: 5,
        title: 'Finance Expert',
        company: 'Finance Corp',
        logo: '⚪', // White briefcase
        location: 'Remote',
        type: 'Contract',
        salary: '$77 / hour',
        referralBonus: '+ $500',
        postedAt: '6 days ago',
        offersEquity: false,
        isHighlighted: false
      },
      {
        id: 6,
        title: 'Mathematics Olympiad Medalists',
        company: 'Education Inc',
        logo: '⚪', // White briefcase
        location: 'Remote',
        type: 'Contract',
        salary: '$40-$50 / hour',
        referralBonus: '+ $500',
        postedAt: '16 days ago',
        offersEquity: false,
        isHighlighted: false
      }
    ];
    setJobs(mockJobs);
  }, []);

  // Redirect to alice-job-board-frontend
  const redirectToAliceJobBoard = (path = '/') => {
    // Alice Job Board is running on port 5001
    const aliceJobBoardUrl = process.env.REACT_APP_ALICE_JOB_BOARD_URL || 'http://localhost:5001';
    window.open(`${aliceJobBoardUrl}${path}`, '_blank');
  };

  const handleApply = (jobId) => {
    // Redirect to alice-job-board-frontend with job application
    redirectToAliceJobBoard(`/jobs/${jobId}/apply`);
  };


  const getFilterIcon = (filter) => {
    switch (filter) {
      case 'trending':
      case 'newest':
        return (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
      case 'most-pay':
        return (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        );
      default:
        return (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      {/* Main Content Area */}
      <div className="flex flex-col">
        {/* Header */}
        <div className="bg-white border-b border-[#e5e7eb] p-6">
          <h1 className="text-3xl font-bold text-[#0a0908] mb-6">Explore opportunities</h1>

          {/* Filter and Search Bar */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {/* Filter Buttons */}
              <div className="flex space-x-2">
                {[
                  { key: 'trending', label: 'Trending' },
                  { key: 'newest', label: 'Newest' },
                  { key: 'most-pay', label: 'Most pay' }
                ].map((filter) => (
                  <button
                    key={filter.key}
                    onClick={() => setActiveFilter(filter.key)}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                      activeFilter === filter.key
                        ? 'bg-[#f7911d] text-white'
                        : 'bg-[#f0f0f0] text-[#4f4f4f] hover:bg-[#e5e7eb]'
                    }`}
                  >
                    {getFilterIcon(filter.key)}
                    <span>{filter.label}</span>
                  </button>
                ))}
              </div>

              {/* Search */}
              <div className="relative">
                <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#9c9c9c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder="Search jobs..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-[#d1d5db] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f7911d] focus:border-transparent"
                />
              </div>
            </div>

            {/* Refer & Earn Button */}
            <button
              onClick={() => redirectToAliceJobBoard('/referrals')}
              className="flex items-center space-x-2 bg-[#f7911d] text-white px-4 py-2 rounded-lg hover:bg-[#e67e0a] transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span>Refer & earn</span>
            </button>
          </div>
        </div>

        {/* Job Listings */}
        <div className="flex-1 p-6">
          <div className="space-y-4">
            {jobs.map((job) => (
              <div
                key={job.id}
                className={`bg-white rounded-lg border p-4 hover:shadow-md transition-all cursor-pointer ${
                  job.isHighlighted ? 'border-[#f7911d] bg-[#fff0de]' : 'border-[#e5e7eb]'
                }`}
                onClick={() => handleApply(job.id)}
              >
                <div className="flex items-start justify-between">
                  {/* Left: Company Logo and Job Details */}
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-[#f0f0f0] rounded-lg flex items-center justify-center text-2xl">
                      {job.logo}
                    </div>

                    <div className="flex-1">
                      <h3 className="font-semibold text-[#0a0908] mb-1">{job.title}</h3>
                      <div className="flex items-center space-x-2 text-sm text-[#4f4f4f] mb-2">
                        <span>{job.company}</span>
                        {job.offersEquity && (
                          <span className="text-[#10b981]">• Offers equity</span>
                        )}
                        <span>• Posted {job.postedAt}</span>
                      </div>
                    </div>
                  </div>

                  {/* Right: Compensation and Apply */}
                  <div className="flex flex-col items-end space-y-2">
                    <div className="text-right">
                      <div className="text-[#10b981] font-semibold text-sm">
                        {job.referralBonus}
                      </div>
                      <div className="text-[#0a0908] font-medium">
                        {job.salary}
                      </div>
                      <div className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                        job.type === 'Full-time'
                          ? 'bg-[#d1fae5] text-[#065f46]'
                          : 'bg-[#dbeafe] text-[#1e40af]'
                      }`}>
                        {job.type}
                      </div>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleApply(job.id);
                      }}
                      className="bg-[#f7911d] text-white px-4 py-2 rounded-lg hover:bg-[#e67e0a] transition-colors text-sm font-medium"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Candidates;
